import { render, staticRenderFns } from "./urun.vue?vue&type=template&id=4bd57490"
import script from "./urun.vue?vue&type=script&lang=js"
export * from "./urun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports